<h3 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
  <span>Acknowledgment of associated materials</span>
</h3>
<p>
  Please acknowledge that you would like to associate the uploaded materials to
  this hearing.
</p>

<form [formGroup]="form" mat-dialog-content>
  <mat-checkbox
    class="md-field"
    appearance="outline"
    color="primary"
    matInput
    formControlName="acknowledged"
    >I acknowledge that the uploaded material(s) cannot be removed once
    associated and I acknowledge that there are no confidential materials associated.</mat-checkbox
  >
</form>
<div
  mat-dialog-actions
  fxLayout="row"
  fxLayoutAlign="end"
  style="padding-bottom: 20px"
>
  <button mat-stroked-button color="primary" mat-dialog-close>Back</button>
  <button
    mat-raised-button
    color="primary"
    [mat-dialog-close]="form.value"
    [disabled]="!form.value.acknowledged"
  >
    Confirm
  </button>
</div>
